import { Module } from 'vuex';
import { getGroupings, getChannelCategories, getChannelPackages } from './DigitalTVPackagesServices';
import { Grouping, GroupingType, ChannelCategory, ChannelPackage } from './digitalTVPackagesModel';

interface GroupingsState {
    packageGroupings: Grouping[];
    premiumGroupings: Grouping[];
    packageTypes: ChannelPackage[];
    categories: ChannelCategory[];
}

export default {
    namespaced: true,
    state: {
        packageGroupings: [],
        premiumGroupings: [],
        packageTypes: [],
        categories: [],
    },
    actions: {
        async loadReferenceData({ commit, state }): Promise<void> {

            // Loads all reference data asynchronously.
            // Loads all at the same time so it is O(1) rather than O(n).
            // This makes a big difference for the initial load when it has to call the server for each reference type.
            // The normal case is either all will be loaded or none will but this isn't a guarantee
            const promises: Promise<any>[] = [];
            // Push the promise for each type that hasn't yet been loaded with a unique (arbitrary) type
            if (state.packageGroupings.length === 0 || state.premiumGroupings.length === 0) {
                promises.push(getGroupings().then(groupings => ({ id: 1, results: groupings })));
            }
            if (state.categories.length === 0) {
                promises.push(getChannelCategories().then(categories => ({ id: 2, results: categories })));
            }
            if (state.packageTypes.length === 0) {
                promises.push(getChannelPackages().then(packages => ({ id: 3, results: packages })));
            }

            // When all are complete set the data for each type that returned data.
            (await Promise.all(promises)).forEach(result => {
                switch (result.id) {
                    case 1:
                        commit('setPackageGroupings', result.results.filter((grouping: Grouping) => grouping.type === GroupingType.PACKAGE));
                        commit('setPremiumGroupings', result.results.filter((grouping: Grouping) => grouping.type === GroupingType.PREMIUM));
                        break;
                    case 2:
                        commit('setCategories', result.results);
                        break;
                    case 3:
                        commit('setPackageTypes', result.results);
                        break;
                }
            });
        },
    },
    mutations: {
        setPackageGroupings(state, payload: Grouping[]) {
            state.packageGroupings = payload;
        },
        setPremiumGroupings(state, payload: Grouping[]) {
            state.premiumGroupings = payload;
        },
        clearGroupings(state) {
            state.packageGroupings = [];
            state.premiumGroupings = [];
        },
        setCategories(state, payload: ChannelCategory[]) {
            state.categories = payload;
        },
        clearCategories(state) {
            state.categories = [];
        },
        setPackageTypes(state, payload: ChannelPackage[]) {
            state.packageTypes = payload;
        },
        clearPackageTypes(state) {
            state.packageTypes= [];
        }
    },
} as Module<GroupingsState, any>;
